import { MapPin, Table } from 'react-feather';
import { Circle, Grid } from 'react-feather';
// permission modules
import modules from '@src/service/modules';

export default [
    {
        id: 'location',
        title: 'Location',
        icon: <MapPin size={20} />,
        children: [
            {
                id: 'state',
                title: 'State',
                icon: <Circle size={12} />,
                navLink: '/location/state'
            },
            {
                id: 'district',
                title: 'District',
                icon: <Circle size={12} />,
                navLink: '/location/district'
            },
            {
                id: 'taluka',
                title: 'Taluka',
                icon: <Circle size={12} />,
                navLink: '/location/taluka'
            },
            {
                id: 'city',
                title: 'City',
                icon: <Circle size={12} />,
                navLink: '/location/city'
            }
        ]
    }
];
